t = require('app/scripts/views/internal/teacup-with-helpers')('list_add')

module.exports = t.renderable ({ tooManyTotalLists, tooManyOpenLists, isFirstList }) ->
  tooManyLists = tooManyTotalLists || tooManyOpenLists

  t.form ->
    t.a { href: '#', class: t.classify('open-add-list js-open-add-list': !tooManyLists, 'too-many-lists': tooManyLists) }, ->
      t.span '.placeholder', ->
        if tooManyTotalLists
          t.format 'you-have-too-many-lists'
        else if tooManyOpenLists
          t.format 'you-have-too-many-open-lists'
        else
          t.icon 'add'
          if isFirstList
            t.format 'add-a-list'
          else
            t.format 'add-another-list'

    if !tooManyLists
      placeholder = t.l 'enter-list-title-ellipsis'
      saveText = t.l 'add-list'

      t.input '.list-name-input', {
        type: 'text',
        name: 'name',
        placeholder: placeholder,
        autocomplete: 'off',
        dir: 'auto',
        maxLength: 512
      }

      t.div '.list-add-controls.u-clearfix', ->
        t.input '.primary.mod-list-add-button.js-save-edit', { type: 'submit', value: saveText }
        t.a '.icon-lg.icon-close.dark-hover.js-cancel-edit', { href: '#' }
